import React, { useState } from 'react';
import { Card, Alert, Container, Button as ButtonB, Form } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import { Button } from '../components/ButtonElement';
import { db } from '../firebase';
import styled from 'styled-components';
export const NavLogo = styled(Link)`
color: #fff;
display:flex;
justify-self:flex-start;
align-items:center;
margin-left:24px;
font-weight:bold;
text-decoration:none;
cursor: pointer;
&:hover{
    text-decoration:none;
    color:#fff;
}
`
export default function UploadProfile() {
    const [error, setError] = useState("");
    const { currentUser, logout } = useAuth();
    const [userRole, setUserRole] = useState();
    const history = useHistory();
    async function handleLogout() {
        setError('');
        try {
            await logout();
            history.pushState('/login');
        } catch {
            setError('Failed to logout');
        }
    }

    const addUserRole = (event) => {
        event.preventDefault();
        if (userRole) {
            db.collection('users').doc(currentUser.uid).set({
                role: 'therapist',
            });
        } else {
            db.collection('users').doc(currentUser.uid).set({
                role: 'user',
            });
        }
    }
    return (
        <Container style={{ minHeight: "100vh", minWidth: "100vw", backgroundColor: '#01bf71', overflowY: 'hidden' }}>
            <NavLogo to="/" style={{ position: "absolute", marginTop: '20px' }}>MindSpace</NavLogo>
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "90vh", minWidth: "90vw", backgroundColor: '#01bf71' }}>
                <div className="w-100" style={{ maxWidth: "400px", paddingTop: "30px" }}>
                    <Card>
                        <Card.Body>
                            <h2 className="text-center mb-4">Profile</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <strong>Email: </strong>{currentUser.email}
                            <Form action="" style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                                <span>Are you a Proffesional<input type='checkbox' value={userRole} onChange={() => setUserRole(!userRole)} /></span>
                                <Button type="submit" onClick={addUserRole}>Add Role</Button>
                            </Form>
                            <Link to="/update-email-password" className="btn btn-primary w-100 mt-3">
                                Update Email Password
                    </Link>
                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        <ButtonB variant="link" onClick={handleLogout} style={{ color: '#fff' }}>Logout</ButtonB>
                    </div>
                </div>
            </Container>
        </Container>
    )
}